import { GROUPE_ORDER } from '../constants/planningConstants';

export const transformPlanningData = (data) => {
  const { hierarchie, totauxParPersonne } = data;

  // Ordre personnalisé des personnes
  const CUSTOM_ORDER = [
    '798796785_Afef GHARIANI',
    '799016904_khouloud MOALLA',
    '798798662_SLIM SMAOUI',
    '798792784_LILIA BEN ABDALLAH',
    '798864978_Ameni SOUISSI',
    '852210829_Syrine DRIRA',
    '877370106_Sirine GDOURA',
    '798864714_Ayouni Amira',
    '852438682_Ons Naifar',
    '798862264_Sami BEN CHIDA',
    '799011106_HANEN MAKNI',
    '799010476_RAHMA CHAKER',
    '831940668_Islem GARGOURI',
    '807375993_Ons CHIBOUB',
    // Position 14: autres personnes seront insérées ici
    '798787607_Direction General',
    'UNKNOWN_Non assigné'
  ];

  // Extraire toutes les personnes uniques (en excluant Direction General et Non assigné)
  const personnesSet = new Set();
  Object.values(hierarchie).forEach((groupe) => {
    Object.values(groupe).forEach((projectGroup) => {
      // projectGroup est maintenant un objet avec { status, categories }
      const categories = projectGroup.categories || projectGroup; // Compatibilité avec ancienne structure
      Object.values(categories).forEach((categorie) => {
        Object.keys(categorie).forEach((personneKey) => {
          // Exclure Direction General et Non assigné
          if (personneKey !== 'sumJour' && 
              categorie[personneKey].taches &&
              personneKey !== '798787607_Direction General' &&
              personneKey !== 'UNKNOWN_Non assigné') {
            personnesSet.add(personneKey);
          }
        });
      });
    });
  });

  // Convertir en tableau avec métadonnées
  const personnesArray = Array.from(personnesSet).map((key) => {
    const [id, ...nameParts] = key.split('_');
    return {
      key,
      id,
      fullName: nameParts.join('_'),
    };
  });

  // Fonction de tri personnalisée
  const sortPersonnes = (personnesArray) => {
    // Séparer les personnes en 2 groupes (plus besoin du groupe "last")
    const ordered = []; // Personnes dans l'ordre défini
    const others = [];  // Autres personnes (non listées)

    personnesArray.forEach((personne) => {
      const index = CUSTOM_ORDER.indexOf(personne.key);
      
      if (index !== -1) {
        // Personne dans l'ordre défini (Direction General et Non assigné sont déjà exclus)
        ordered.push({ personne, index });
      } else {
        // Personne non listée
        others.push(personne);
      }
    });

    // Trier les personnes ordonnées selon leur index
    ordered.sort((a, b) => a.index - b.index);
    
    // Trier les autres personnes alphabétiquement
    others.sort((a, b) => a.fullName.localeCompare(b.fullName));

    // Combiner: ordered + others
    return [
      ...ordered.map(o => o.personne),
      ...others
    ];
  };

  // Appliquer le tri personnalisé
  const personnes = sortPersonnes(personnesArray);

  // Construire les lignes du tableau avec tri dynamique des catégories
  const rows = [];

  // Trier les groupes selon l'ordre prédéfini
  const sortedGroupes = Object.keys(hierarchie).sort((a, b) => {
    const indexA = GROUPE_ORDER.indexOf(a);
    const indexB = GROUPE_ORDER.indexOf(b);
    
    // Si les deux sont dans l'ordre prédéfini, trier selon cet ordre
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    // Si seulement A est dans l'ordre, A vient en premier
    if (indexA !== -1) return -1;
    // Si seulement B est dans l'ordre, B vient en premier
    if (indexB !== -1) return 1;
    // Si aucun n'est dans l'ordre, trier alphabétiquement
    return a.localeCompare(b);
  });

  sortedGroupes.forEach((nomGroupe) => {
    const projets = hierarchie[nomGroupe];
    // Ligne de groupe
    rows.push({
      type: 'groupe',
      nomGroupe,
    });

    // Lignes de projets - Traiter toutes les catégories de la même manière
    Object.entries(projets).forEach(([nomProjet, projectGroup]) => {
      // projectGroup est maintenant un objet avec { status, categories }
      const projectStatus = projectGroup.status || null;
      const categories = projectGroup.categories || projectGroup; // Compatibilité avec ancienne structure
      
      let firstRowForProject = true;
      let totalRowsForProject = 0;

      // Compter d'abord le nombre total de lignes pour ce projet (en excluant Direction General et Non assigné)
      Object.entries(categories).forEach(([categorieTache, personnesObj]) => {
        Object.entries(personnesObj).forEach(([personneKey, personneData]) => {
          if (personneKey !== 'sumJour' && 
              personneData.taches && 
              personneData.taches.length > 0 &&
              personneKey !== '798787607_Direction General' &&
              personneKey !== 'UNKNOWN_Non assigné') {
            totalRowsForProject++;
          }
        });
      });

      // Créer les lignes pour chaque catégorie et chaque personne (en excluant Direction General et Non assigné)
      Object.entries(categories).forEach(([categorieTache, personnesObj]) => {
        Object.entries(personnesObj).forEach(([personneKey, personneData]) => {
          if (personneKey !== 'sumJour' && 
              personneData.taches && 
              personneData.taches.length > 0 &&
              personneKey !== '798787607_Direction General' &&
              personneKey !== 'UNKNOWN_Non assigné') {
            // Extraire les détails complets de chaque tâche
            const tachesAvecDetails = personneData.taches.map(t => ({
              nomTache: t.nomTache,
              status: t.status,
              nombreJour: t.nombreJour || 0,
              billableHours: t.billableHours || "0.0"
            }));
            
            // Créer les données pour cette personne avec détails des tâches
            const tachePersonnesData = {};
            tachePersonnesData[personneKey] = {
              sumJour: personneData.sumJour || 0,
              sumBillable_jour: personneData.sumBillable_jour || 0,
              tachesDetails: tachesAvecDetails // Ajouter les détails de chaque tâche
            };

            rows.push({
              type: 'tache-detail',
              nomProjet,
              projectStatus, // Ajouter le statut du projet
              nomGroupe,
              categorieTache,
              taches: tachesAvecDetails,
              personnesData: tachePersonnesData,
              showProjectName: firstRowForProject,
              rowspan: firstRowForProject ? totalRowsForProject : 0,
            });

            firstRowForProject = false;
          }
        });
      });
    });
  });

  // Calculer les totaux par personne avec toutes les données
  const totaux = {};
  personnes.forEach((personne) => {
    const personneStats = totauxParPersonne[personne.key];
    totaux[personne.key] = {
      totalJours: personneStats?.totalJours || 0,
      sum_jourTravail: personneStats?.sum_jourTravail || 0,
      nombreTaches: personneStats?.nombreTaches || 0,
      nombreTachesCompleted: personneStats?.nombreTachesCompleted || 0,
      pourcentageRealisation: personneStats?.pourcentageRealisation || 0,
    };
  });

  return {
    personnes,
    rows,
    totaux,
  };
};
